<app-closable-modal-template maxWidth="none" class="u-padding-none" *ngIf="hasClosableModal; else content">
    <ng-container modal-header>
        <ng-content select="[modal-header]"></ng-content>
    </ng-container>
    <ng-container *ngTemplateOutlet="content"></ng-container>
</app-closable-modal-template>

<ng-template #content>
    <app-loading-container [loading]="loading">
        <main
            class="__main __two-panel-modal__main u-h100p"
            [class.hide-side-panel]="!hasSidePanel"
            [class.__left--fixed-width]="type === twoPanelType.LeftMaxRightFr"
        >
            <section class="__left u-bordered-right u-flex u-flex-column u-flex-justify-content-space-between">
                <div class="__left-body">
                    <ng-content select="[modal-left]"></ng-content>
                </div>
                <div class="__left-actions u-margin">
                    <ng-content select="[modal-left-actions]"></ng-content>
                </div>
            </section>
            <section class="__right" *ngIf="hasSidePanel">
                <ng-content select="[modal-right]"></ng-content>
            </section>
        </main>
    </app-loading-container>
</ng-template>
